<template>
  <div class="edit-studio-container user-com">
    <div class="admin-header-container admin-header-sec">
      <div :class="{ 'admin-header': user.id != 'new_studio' }">
        <h1 class="title admin-title-sec" v-if="user.id != 'new_user'">{{ $t('edit-user') + ': ' + user.displayFirstName
          + " " +
          user.displayLastName }} </h1>
        <h1 class="title admin-title-sec" v-if="user.id == 'new_user'">{{ $t('add-user') }} </h1>
        <div>
          <div class="img-container" @click="togglePopup(true, false, true)">
            <img v-if="user.photo" width="90" :src="originalUserPhoto" />
            <img v-if="!user.photo && user.id != 'new_user'" width="90"
              :src="fit20.storageBaseUrl + '/member/default.svg'" />
          </div>
          <div class="btn-container">
            <span id="cancelUser" class="fit20-btn cancel-btn-disable" @click="cancelEditing">{{ $t('cancel') }}</span>
            <span id="saveUser" class="fit20-btn save-btn-disable" @click="saveUser">{{ $t('save') }}</span>
          </div>
        </div>
      </div>
    </div>
    <main class="tab-content">
      <h2 class="item text-secondary">{{ $t('general-info') }}</h2>
      <form class="form-container admin-studio-tab-pane fade show active" id="admin_user_info">
        <div class="field-sec">
          <label>{{ $t('first-name') }}</label>
          <input type="text" class="form-control" v-model="user.displayFirstName" />
        </div>
        <div class="field-sec">
          <label>{{ $t('last-name') }}</label>
          <input type="text" class="form-control" v-model="user.displayLastName" />
        </div>
        <div class="field-sec">
          <label>{{ $t('initials') }}</label>
          <input type="text" class="form-control" v-model="user.initials" />
        </div>
        <div class="field-sec">
          <label class="">{{ $t('date-of-birth') }}</label>
          <input type="date" class="form-control" v-model="user.birthDate" min="1900-01-01" :max="maxDate" />
        </div>
        <div class="field-sec">
          <label for="editedStudio_gatewayIPAddress" class="">{{ $t('gender') }}</label>
          <select id="editedStudio_gatewayIPAddress" class="" v-model="user.gender">
            <option value="">{{ $t('') }}</option>
            <option value="male">{{ $t('male') }}</option>
            <option value="female">{{ $t('female') }}</option>
            <option value="other">{{ $t('other') }}</option>
          </select>
        </div>
        <div class="field-sec">
          <label class="">{{ $t('email') }}</label>
          <input type="email" class="form-control" v-model="user.email" />
        </div>
        <div class="field-sec">
          <label>{{ $t('phone') }}</label>
          <input type="text" class="form-control" v-model="user.phone">
        </div>
        <div class="field-sec">
          <label>{{ $t('language') }}</label>
          <select v-model="user.language">
            <option v-for="language in fit20.languages" :value="language.code" :key="language.code">{{ language.name }}
            </option>
          </select>
        </div>
        <div class="field-sec">
          <label>{{ $t('role') }}</label>
          <select class="" v-model="user.role">
            <option value="user">{{ $t('user') }}</option>
            <option value="admin">{{ $t('admin') }}</option>
          </select>
        </div>
        <div class="field-sec">
          <label>{{ $t('active') }}</label>
          <select class="" v-model="user.active">
            <option value="true">{{ $t('yes') }}</option>
            <option value="false">{{ $t('no') }}</option>
          </select>
        </div>
        <AddRemoveItem v-if="user.id != 'new_user' && user.role != 'admin'" title="user-in" :data="userStudios"
          :selectItem="selectItem" :removeItem="removeUserFromStudio" :togglePopup="togglePopup"
          :popupParams="[true, true, false]" name1="name" name2="" :fit20="fit20"></AddRemoveItem>
        <div class="ex-member-container" v-if="user.id != 'new_user' && user.role != 'admin'">
          <h2 class="text-secondary">{{ $t('ex-user-in') }} </h2>
          <div class="flex ex-member-flex" v-for="item in exUserStudios">
            <div class="ex-member-item pointer" @click="selectItem(item.id)"> {{ item.name }}</div>
            <img width="50" :src="fit20.storageBaseUrl + '/static/icons/%2B.png'" @click="reactiveStudio(item.id)" />
          </div>
        </div>
        <div class="fade"></div>
      </form>
    </main>
    <div class="popup-overlay" v-if="showStudioPopup">
      <div class="popup-content">
        <div>{{ $t('ad-studio-2-user') }}</div>
        <input type="text" @input="openSelectDropdown" @click="openSelectDropdown" v-model="studioFilter"
          :placeholder="$t('placeholder1')" />
        <div v-show="isDropdownOpen" class="dropdown-container">
          <div class="dropdown-options">
            <div v-for="studio in toAddStudios" :key="studio.id" @click="selectAnItem(studio)" class="dropdown-option">
              {{ studio.displayName }}
            </div>
          </div>
        </div>
        <div class="btn-container">
          <span class="fit20-btn cancel-btn-disable" @click="togglePopup">{{ $t('cancel') }}</span>
          <span class="fit20-btn save-btn-disable" @click="addItem">{{ $t('ok') }}</span>
        </div>
      </div>
    </div>
    <div class="popup-overlay" v-if="showPhotoPopup">
      <Photo :title="user.displayFirstName" :id="user.id" :changePhoto="changePhoto" :savePhoto="savePhoto"
        :togglePopup="togglePopup" :photo="userPhoto" :fit20="fit20" :togglePopupValues="[false, false, true]" />
    </div>
  </div>
</template>

<script>
import isEqual from 'lodash/isEqual';
import AddRemoveItem from './AddRemoveItem.vue';
import Photo from '../Photo.vue';
import { isValidEmail } from "../../actions/global.js";

export default {
  name: 'User',
  components: {
    AddRemoveItem,
    Photo
  },
  props: ["selectTab", "admin_fit20", "fit20", "formatDate", "admin"],
  data() {
    return {
      userStudios: [],
      exUserStudios: [],
      user: {},
      studios: [],
      toAddStudios: [],
      originalUserPhoto: false,
      originalUser: {},
      updated: false,
      maxDate: this.formatDate(new Date()),
      originalStudios: [],
      showPhotoPopup: false,
      showStudioPopup: false,
      studioFilter: "",
      isFilter: false,
      isDropdownOpen: false,
      selectedItem: "",
      userPhoto: "",
      newPhoto: false,
    };
  },
  methods: {
    // isValidEmail: function (email) {
    //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //   return emailRegex.test(email);
    // },

    selectTrainer: function () {
      console.log("should go to selected item");
    },
    selectItem: function () {
      console.log("should go to selected item");
    },
    saveUser: async function () {
      let isEmailExist;
      if (isEqual(this.user, this.originalUser)) {
        alert(this.$t('general-no-changes'));
      } else if (!this.user.displayFirstName) {
        alert(this.$t('required-field').replace('{field}', this.$t('first-name')));
      } else if (!this.user.initials) {
        alert(this.$t('required-field').replace('{field}', this.$t('initials')));
      } else if (this.user.email && this.user.email.length > 0 && !isValidEmail(this.user.email)) {
        alert(this.$t('invalid-email'));
      }
      else {
        if (this.user.id == "new_user") {
          this.user.id = false;
          let user = await fetch(this.fit20.baseUrl + "/api/users/user?email=" + this.user.email + "&accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email);
          let userData = await user.json();
          if (userData && userData.email) {
            isEmailExist = true;
          }
        }
        if (!isEmailExist) {
          this.user.firstName = this.user.displayFirstName.toLowerCase();
          this.user.lastName = this.user.displayLastName.toLowerCase();
          this.user.studios = [...this.studios];

          let updateUser = await fetch(this.fit20.baseUrl + "/api/users/" + this.fit20.user.email + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.user),
          });
          let updatedUser = await updateUser.json();
          this.admin_fit20.user = JSON.parse(JSON.stringify(updatedUser));

          let existUser = this.admin_fit20.users.find(item => item.id == updatedUser.id);
          if (existUser) {
            console.log("exist member");
            existUser = updatedUser;
          } else {
            this.admin_fit20.users = [...this.admin_fit20.users, updatedUser];
          }
          // this.originalMember = updatedMember;
          this.admin_fit20.studio = '';
          this.updated = true;
        } else {
          alert(this.$t('email-existed'));
        }
      }


    },
    cancelEditing: function () {
      if (!isEqual(this.user, this.originalUser)) {
        this.admin_fit20.user = {
          ...this.originalUser
        };
        this.updated = true;
      }
    },
    // removeUserFromStudio: function (userId) {
    //   this.studio.users = this.studio.users.filter(user => user.id != userId);
    // },
    reactiveStudio: function (studioId) {
      const studioIndex = this.studios.findIndex(studio => studio.id == studioId);
      if (studioIndex !== -1) {
        this.$set(this.studios[studioIndex], 'active', true);
      }
      console.log(this.studios[studioIndex]);
    },
    removeUserFromStudio: function (studioId) {
      console.log("reomve");

      const studioIndex = this.studios.findIndex(studio => studio.id == studioId);
      if (studioIndex !== -1) {
        this.$set(this.studios[studioIndex], 'active', false);
      }
    },
    addItem: function () {
      this.studios = [...this.studios, {
        id: this.selectedItem.id,
        active: true,
        name: this.selectedItem.displayName,
        role: 'trainer',
      }];
      // console.log(this.selectedItem);

      this.isFilter = false;
      this.showStudioPopup = false;

    },
    togglePopup: async function (open, studio, photo) {
      if (!photo) {
        this.studioFilter = "";
        this.selectedItem = false;
        if (studio) {
          this.toAddStudios = this.fit20.studios.filter(studio => studio.active == true);

          this.toAddStudios = this.toAddStudios.filter(studio => !this.studios.some(existStudio => existStudio.id == studio.id));

        }
        this.showStudioPopup = !this.showStudioPopup;
      } else if (photo) {
        console.log("photo");
        this.showPhotoPopup = !this.showPhotoPopup;
        this.userPhoto = this.fit20.storageBaseUrl + "/user/" + (this.user.photo ? this.user.id + ".png?generation=" + this.user.photo : "default.svg");
        this.newPhoto = false;
      }
    },
    openSelectDropdown: function () {
      this.isDropdownOpen = true;
    },
    selectAnItem(item) {
      this.studioFilter = item.name;
      this.selectedItem = item;
      this.isDropdownOpen = false;
    },
    changePhoto: function (e) {
      const file = e.target.files[0]; // Get the first selected file

      if (file) {
        // Use FileReader to read the selected file
        const reader = new FileReader();
        reader.onload = (e) => {
          this.userPhoto = e.target.result; // Set the imageUrl to the data URL
          this.newPhoto = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    savePhoto: async function () {
      if (this.newPhoto) {
        console.log("there is a new photo");
        const formData = new FormData();
        formData.append('image', this.newPhoto);
        const res = await fetch(this.fit20.baseUrl + "/api/photos/user/" + this.user.id + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email, {
          method: 'POST',
          body: formData,
        });
        if (res.ok) {
          let photo = await res.json();

          this.admin_fit20.user.photo = photo;
          console.log("Upload photo done");
        } else {
          // Handle errors (e.g., show an error message)
          alert('upload-failed');
          console.error('Upload failed.');
        }
      }
      console.log("save photo");
      // this.originalMemberPhoto = JSON.parse(JSON.stringify(this.newPhoto));
      // to do : change the photo in the members array.............................
      this.newPhoto = false;
      this.updated = true;
      this.showPhotoPopup = !this.showPhotoPopup;
    },
    // handleImageError(event) {
    //   event.target.src = this.defaultStudioPhoto; // Set the src to the default image path
    // },
  },
  watch: {
    'admin_fit20.user': {
      immediate: true, // This runs the watcher immediately on mount
      deep: true, // Watch for changes in nested properties
      async handler(newVal) {
        if (!newVal) {
          this.user.id = '';
        }
        if (newVal && newVal.id && (!this.user.id || this.user.id != newVal.id || this.updated)) {
          this.user = newVal;
          console.log("start update");
          if (this.admin) {

            this.studios = [];
            newVal.studios.forEach((item1) => {
              if (this.fit20.studios.find((item2) => item2.id == item1.id)) {
                this.studios.push({
                  ...item1,
                  name: this.fit20.studios.find((item2) => item2.id == item1.id).name || "unknown",
                });
              }

            });
          }
          this.user.studios = JSON.parse(JSON.stringify(this.studios));
          this.userStudios = this.studios.filter(studio => studio.active);
          this.exUserStudios = this.studios.filter(studio => !studio.active);
          this.user.birthDate = this.formatDate(this.user.birthDate);
          this.originalUser = JSON.parse(JSON.stringify(this.user))
          this.originalUser.birthDate = this.formatDate(this.user.birthDate);

          this.userPhoto = this.fit20.storageBaseUrl + "/user/" + (this.user.photo ? this.user.id + ".png?generation=" + this.user.photo : "default.svg");
          this.originalUserPhoto = this.fit20.storageBaseUrl + "/user/" + (this.user.photo ? this.user.id + ".png?generation=" + this.user.photo : "default.svg");

          console.log("end update");
          this.updated = false;
        }
      }
    },
    user: {
      deep: true, // Watch for changes in nested properties
      handler(newVal) {

        if (isEqual(newVal, this.originalUser)) {
          $('#cancelUser').removeClass("cancel-btn-active");
          $('#saveUser').removeClass("save-btn-active");
        } else {
          if (!$('#cancelUser').hasClass('cancel-btn-active')) {
            $('#cancelUser').addClass("cancel-btn-active");
            $('#saveUser').addClass("save-btn-active");
          }
        }
      }
    },
    'studios': {
      deep: true,
      handler(newVal) {
        console.log(newVal);
        this.userStudios = newVal.filter(studio => studio.active);
        this.exUserStudios = newVal.filter(studio => !studio.active);
        if (!isEqual(newVal, this.user.studios)) {
          console.log("updated studios")
          this.user.studios = JSON.parse(JSON.stringify(newVal));
        }
      }
    },
    studioFilter: {
      deep: true, // Watch for changes in nested properties
      handler(newVal) {
        if (newVal.length > 0) {
          this.toAddStudios = [...this.fit20.studios].filter(studio => (studio.name).includes(newVal.toLowerCase().trim()) && studio.active == true && !this.studios.some(existStudio => existStudio.id == studio.id));
          this.isFilter = true;
        } else if (this.isFilter) {
          this.toAddStudios = [...this.fit20.studios];
          this.isFilter = false;
        }
      }
    },
  }
};
</script>

<style>
.user-com.edit-studio-container {
  width: 100%;
  height: calc(100vh - 30px);
  /* Adjust as needed */
  overflow: auto;
}

.user-com .tab-content {
  padding-top: 15px;
}

.user-com .tab-content h2 {
  margin-left: 10px;
  margin-top: 20px;
}

.user-com .img-container img {
  border-radius: 15px;
  cursor: pointer;
  max-width: 150px;
}

.user-com .admin-studio-tab-pane {
  display: none;
  padding-bottom: 30px;
}

.user-com .form-container.active {
  display: flex !important;
  flex-wrap: wrap;
  justify-content: space-around;
}

.user-com .form-container div:not(.add-item) {
  width: calc(100% / 2 - 30px);
}

.user-com .form-container label {
  display: block;
}

.user-com .studio-users {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.user-com .users-col {
  width: calc(100%);
}

.user-com .studio-machines {
  width: 100%;
}

.user-com .ex-member-container {
  margin-top: 10px;
}

.user-com .ex-member-flex {
  width: 100% !important;
}

.user-com .ex-member-item {
  width: 80% !important;
  border: solid 1px var(--fit20-lighter-gray);
  padding: 5px 7px;
  border-radius: 10px;
  margin-bottom: 7px;
}

.user-com .ex-member-container img {
  margin-bottom: 7px;

}

.user-com .measure-div {
  position: relative;
}

.user-com .kg {
  position: absolute;
  right: 60px;
  bottom: 5px;
}
</style>
